import { CheckRounded, Style } from "@mui/icons-material";

const FlashReportNav = ({ totalCorrect, total }) => {
  return (
    <nav>
      <ul className="report-nav">
        <li>
          <div>
            <Style sx={{ transform: "rotate(90deg)" }} color="iconGray" />
          </div>
          <h6 className="mb-0">Evaluation Report</h6>
        </li>
        <li>
          <div className="side-by-side">
            <p className="mb-0">
              <CheckRounded
                color="green"
                fontSize="small"
                sx={{ marginRight: "0.5" }}
              />
              {totalCorrect} / {total} pts
            </p>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default FlashReportNav;
